import loadable from '@loadable/component';
import Loading from '../components/Loader';

const Activate = loadable(
  () => import(/* webpackChunkName: "vouchers" */ '../containers/VoucherActivate'),
  { fallback: Loading }
);

export default Activate;
